import { gql } from '@apollo/client';

export const LIST_ALL_ROLES = gql`
  query ListAllRoles {
    listAllRoles {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;

export interface RoleFlatType {
  id: number | string;
  name: string;
  description?: string | null;
  createdAt?: number | null;
  updatedAt?: number | null;
}

export interface ListAllRolesResponse {
  listAllRoles: RoleFlatType[];
}
